const AGENT_UI_URLS = {
  production: 'https://agent-ui.tigerconnect.com/',
  uat: 'https://agent-ui.uat.tigerconnect.com/',
  env7: 'https://agent-ui.env7.tigerconnect.com/',
};

// REACT_APP_TIGER_AGENT_URL, when set, always wins — this is the local-dev url
export default function getTigerAgentUrl(apiEnv: string): string {
  const override = process.env.REACT_APP_TIGER_AGENT_URL;
  if (override) return override;
  return (
    AGENT_UI_URLS[apiEnv as keyof typeof AGENT_UI_URLS] ||
    `https://agent-ui.${apiEnv}.tigerconnect.com/`
  );
}
